import { Navigate } from "react-router-dom";
import { useClinicianAuthStore } from "@/stores/clinicianAuthStore";

export function ClinicianGuestOnly({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useClinicianAuthStore((s) => s.isAuthenticated);
  const isLoading = useClinicianAuthStore((s) => s.isLoading);

  if (isLoading) return null; // wait for session restore before deciding
  if (isAuthenticated) return <Navigate to="/clinician" replace />;
  return <>{children}</>;
}
